import React, { useEffect, useRef, useState } from 'react'
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap'
import { supabase } from '../../functions/supabaseClient'
import { useCallback } from 'react'

const QuestionCallout = ({ toggleFunction }) => {
	return (
		<>
			<div className='question-callout'>
				<i className="bi bi-question-circle"></i>
				<div className='span-group'>
					<span>¿Tiene alguna duda acerca del Concurso?</span>
					<button 
						className='callout-link'
						onClick={() => toggleFunction(true)}
					>
						{"» Formule su pregunta aquí"}
					</button>
				</div>
			</div>
		</>
	)
}

const ConcursoQuestionModal = ({ toggleFunction, modalState }) => {
	const [sending, setSending] = useState(false) // Variable de estado de envío
	const [question, setQuestion] = useState('') // Contenido del textarea de preguntas
	const [status, setStatus] = useState(null) // Estado de la solicitud
	const alertTimerRef = useRef(null)
	const [alert, setAlert] = useState({
		show: false,
		variant: 'primary',
		message: '',
		dismissible: true,
		delay: 0
	})

	const handleSubmit = async (e) => {
		e && e.preventDefault();

		if(!question || typeof question !== 'string' || !question.trim()) return setAlert({
			show: true,
			variant: 'warning',
			message: 'Formato inválido. Verifique el texto introducido e intente nuevamente. ',
			dismissible: true,
			delay: 5000
		});

		setSending(true);

		const { error } = await supabase
			.from('preguntas_concurso')
			.insert([{ contenido: question.trim() }]);

		if(error) {
			setStatus('error')
			setAlert({
				show: true,
				variant: 'danger',
				message: 'Error al enviar datos',
				dismissible: true,
				delay: 7000
			})
			// console.log(error);
		} else {
			setStatus('success')
			setAlert({
				show: true,
				variant: 'success',
				message: 'Sus inquietudes han sido enviadas correctamente. \n\nLe invitamos a estar atento a nuestros canales oficiales. Muchas gracias. ',
				dismissible: false,
				delay: 0
			})
		}
		setSending(false)

		setTimeout(() => {
			handleClose()
		}, 10000);
	}

	const handleClose = () => {
		setSending(false)
		setStatus(null)
		setQuestion('')
		toggleFunction(false)
		closeAlert()
	}

	const closeAlert = useCallback(() => {
		if(alertTimerRef.current) {
			clearTimeout(alertTimerRef.current)
		}
		setAlert(prev => ({ ...prev, show: false }))
	}, [])

	useEffect(() => {
		if(!alert.show) return;

		if(alert.delay && alert.delay > 0){
			alertTimerRef.current = setTimeout(() => {
				closeAlert()
			}, alert.delay);
		}

		return () => {
			clearTimeout(alertTimerRef.current)
		};
	}, [alert.delay, alert.show, closeAlert]);

  return (
    <Modal 
			show={modalState} 
			onHide={handleClose} 
			dialogClassName='centered concurso-question-modal'
			aria-labelledby="contained-modal-title-vcenter"
			backdrop="static"
      centered
		>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
				<div className='form-container'>

					<p>Si tiene alguna duda con respecto al Concurso 2026 o sus procedimientos, a continuación podrá expresar sus inquietudes para ser posteriormente atendidas. </p>

					<p>Estas preguntas serán respondidas mediante una transmisión en vivo de Instagram que será anunciada próximamente. </p>

					<Alert 
						show={alert.show} 
						variant={alert.variant} 
						dismissible={alert.dismissible}
						onClose={closeAlert}
					>
						<p className='ws-pw' dangerouslySetInnerHTML={{__html: alert.message }} />
					</Alert>

					<Form onSubmit={handleSubmit}>

						<Form.Group className="custom-form-group" controlId="questionForm.Control">
							<Form.Control 
								className='textarea-control' 
								as="textarea" rows={3} 
								placeholder='Escriba sus preguntas aquí'
								onChange={(e) => setQuestion(e.target.value)}
								hidden={status==='success'}
								disabled={sending || status==='success'}
							/>
						</Form.Group>

						<Button 
							className='link-button' 
							variant='primary'
							type='submit'
							hidden={status==='success'}
							disabled={sending || !question.trim()}
						>
							{
								sending ?
								<>
									<Spinner className='modal-spinner' animation="border" />
									Enviando
								</>
								:
								"Enviar"
							}
						</Button>
					</Form>
				</div>
      </Modal.Body>
    </Modal>
  )
}

const QuestionButton = ({ toggleFunction }) => {
	return (
		<div className='question-button-container'>
			<button className='floating-question-button' onClick={() => toggleFunction(true)}>
				<i className="bi bi-question-circle"></i>
			</button>
		</div>
	)
}

export { QuestionCallout, QuestionButton, ConcursoQuestionModal }